import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  VisibilityButton,
} from "@tools";
import { Collapse } from "@material-ui/core";
import { BillingRow, TimelineSectionTitleRow } from "../components";

export const TimelineBilling = observer(() => {
  
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { blockExpansions } = useEstimateEditorSettings();
  
  const { settings, visibility } = structure;
  const { displayTimelineBilling } = settings;
  const { hideTimelineBilling } = visibility;
  
  const className = useVisibilityModeCellClassName(hideTimelineBilling);
  
  const handleTimelineBillingVisibility = () => {
    if(blockExpansions) return;
    settings.setDisplayTimelineBilling(!displayTimelineBilling);
  }
  
  return (
    <>
      <TimelineSectionTitleRow
        code="billing"
        expandable
        expanded={displayTimelineBilling}
        onExpand={handleTimelineBillingVisibility}
        className={className}
        action={visibilityMode &&
          <VisibilityButton
            hidden={hideTimelineBilling}
            onChange={visibility.setHideTimelineBilling}
          />
        }
      />
      <Collapse
        in={displayTimelineBilling}
        timeout="auto"
        mountOnEnter
        unmountOnExit
        className={className}
      >
        <BillingRow />
      </Collapse>
    </>
  );
});